/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Unavailable_SoonInputs */

const en_model_unavailable_soon = /** @type {(inputs: Model_Unavailable_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`soon`)
};

const id_model_unavailable_soon = /** @type {(inputs: Model_Unavailable_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sebentar lagi`)
};

/**
* | output |
* | --- |
* | "soon" |
*
* @param {Model_Unavailable_SoonInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_unavailable_soon = /** @type {((inputs?: Model_Unavailable_SoonInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Unavailable_SoonInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_unavailable_soon(inputs)
	return en_model_unavailable_soon(inputs)
});